import React, {Component} from "react";
import axios from 'axios';
import Constants from '../../../components/Constants/';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import AlertContainer from 'react-alert';

class Versions extends Component {

    constructor(props) {
        super(props);

        this.refreshVersionsList = this.refreshVersionsList.bind(this);
        this.afterSaveCell = this.afterSaveCell.bind(this);
        this.onAddVersion = this.onAddVersion.bind(this);

        this.state = {
            versionsList: null,
            activePage: 1
        };
    
        /*
        * Configurações do alerta
        */
        this.alertOptions = {
            offset: 14,
            position: 'top right',
            theme: 'light',
            time: 10000,
            transition: 'scale'
        }

        this.refreshVersionsList();
    }

    refreshVersionsList(){
      axios({
          method: 'get',
          url: Constants.apiUrl+'/api/v1/desktop-version'
      })
      .then(response => {
          this.setState({
              versionsList: response.data
          });
      });
    }

    afterSaveCell(row, cellName, cellValue) {
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/desktop-version',
          data: row
      })
      .then(response => {
        this.msg.show('Versão salva.', {
          time: 10000,
          type: 'success'
        });
      });
    }

    onAddVersion(row) {

      row.id = null;
      axios({
          method: 'post',
          url: Constants.apiUrl+'/api/v1/desktop-version',
          data: row
      })
      .then(response => {
          this.msg.show('Versão adicionada.', {
            time: 10000,
            type: 'success'
          });
          this.refreshVersionsList();
      });
    }

    renderPaginationShowsTotal(start, to, total) {
      return (
        <p>
          Exibindo de { start } a { to }, total: { total }
        </p>
      );
    }

    createCustomModalHeader(closeModal, save){
      return (
        <InsertModalHeader
          className='model-header'
          title=''
         />
      );
    }

    

    render() {
        if(this.state.versionsList == null) return null;

        const tableOptions = {
            paginationSize: 10,
            hideSizePerPage: true,
            paginationShowsTotal: true,
            paginationShowsTotal: this.renderPaginationShowsTotal,
            onAddRow: this.onAddVersion,
            insertModalHeader: this.createCustomModalHeader
        };        

        const cellEdit = {
          mode: 'dbclick',
          blurToSave: true,
          afterSaveCell: this.afterSaveCell,
        };
        
        return(
            <div>
                <h2>Versões</h2>
                <hr />
                <BootstrapTable ref="table" data={this.state.versionsList} version='4'
                  striped hover pagination insertRow search searchPlaceholder='Pesquisa Geral'
                  options={tableOptions} cellEdit={ cellEdit }>
                    <TableHeaderColumn dataField="version" dataSort={true} width='10%'>Versão</TableHeaderColumn>
                    <TableHeaderColumn dataField="description" editable={{type: 'textarea'}} dataSort={true} width='20%'>Descrição</TableHeaderColumn>
                    <TableHeaderColumn dataField="releaseNotes" editable={{type: 'textarea'}} dataSort={true} width='20%'>Release Notes</TableHeaderColumn>
                    <TableHeaderColumn dataField="id" autoValue isKey={true} width='15%'>ID</TableHeaderColumn>
                </BootstrapTable>                  
                <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
            </div>
        )
    }
}

export default Versions;



// WEBPACK FOOTER //
// ./src/views/admin/Versions/Versions.js